import { Editor } from "@monaco-editor/react";
import { Box, Typography } from "@mui/material";
import React from "react";
import axios from "axios";

export const BodyViewer = ({ fileUrl }) => {
  const [loading, setLoading] = React.useState(false);
  const [content, setContent] = React.useState(null);
  const [error, setError] = React.useState(null);

  const loadBody = async () => {
    if (content || loading) return; // avoid multiple loads
    setLoading(true);

    try {
      const res = await axios.get(fileUrl, {
        responseType: "json",
      });
      const text = res.data;
      let parsed;

      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = text; // fallback if JSON is malformed or plain text
      }

      setContent(parsed);
    } catch (err) {
      console.error(err);
      setError("Failed to load file");
    } finally {
      setLoading(false);
    }
  };

  if (loading || error || !content)
    return (
      <Typography
        variant="body2"
        onClick={!content && !loading ? loadBody : undefined}
        color={error ? "error" : !content ? "primary" : "textSecondary"}
        sx={{
          mt: 1,
          p: 2,
          cursor: !content && !loading ? "pointer" : "default",
        }}>
        {loading ? "Loading body..." : error ? error : "Click to load body..."}
      </Typography>
    );

  const formatted =
    typeof content === "string" ? content : JSON.stringify(content, null, 2);

  return (
    <Box
      sx={{
        mt: 1,
        backgroundColor: "#f5f5f5",
        borderRadius: 1,
      }}>
      <Editor
        height="300px"
        value={formatted}
        defaultLanguage="json"
        options={{
          readOnly: true,
          minimap: { enabled: false },
          wordWrap: "on",
          scrollBeyondLastLine: false,
          overviewRulerLanes: 0,
        }}
      />
    </Box>
  );
};
